import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#mortgage-payment-app', App);
